function beautifyCookies() {
    var actionDiv = '.sd-cmp-26ssN.sd-cmp-3GFtF';
    $(actionDiv).before('<div><a href="#" class="cookies_view_more">'+cookies_view_more+'</a></div>');
    $(actionDiv).before('<div><a href="#" class="cookies_view_less">'+cookies_view_less+'</a></div>');

    $('.sd-cmp-141od').addClass('cookies_collapsed');
    $('.cookies_view_more').click(function () {
        $('.cookies_collapsed').addClass('cookies_expanded');
        $('.cookies_collapsed').removeClass('cookies_collapsed');
    });
    $('.cookies_view_less').click(function () {
        $('.cookies_expanded').addClass('cookies_collapsed');
        $('.cookies_expanded').removeClass('cookies_expanded');
    });
}

var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
            // element added to DOM
            if (mutations[i].addedNodes[0].id === 'sd-cmp') {
                setTimeout(function() {
                    beautifyCookies()
                });
                observer.disconnect();
                break;
            }
        }
    }
});

observer.observe(document.body, {childList: true});
